module.exports = __webpack_public_path__ + "media/components/assets/icons/coldcall_wrong-8c54568637815e1c25fea50197b9f9b0.svg";